module.exports = __webpack_public_path__ + "static/media/sketch.2d3c2868.jpg";